webpackJsonp([1747901367335],{

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.microwaveScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _common = __webpack_require__(39);
	
	var _microwavePanel = __webpack_require__(179);
	
	var _microwavePanel2 = _interopRequireDefault(_microwavePanel);
	
	var _w3cMicrowave = __webpack_require__(905);
	
	var _w3cMicrowave2 = _interopRequireDefault(_w3cMicrowave);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.microwaveScxml = _w3cMicrowave2.default;
	
	var W3CMicrowaveExample = function (_SCComponent) {
	  _inherits(W3CMicrowaveExample, _SCComponent);
	
	  function W3CMicrowaveExample(props) {
	    _classCallCheck(this, W3CMicrowaveExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, _w3cMicrowave2.default));
	  }
	
	  W3CMicrowaveExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '520px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-6', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '520px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _w3cMicrowave2.default,
	            disableAnimation: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'w3c-microwave'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-6', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '520px', border: '1px solid #eee' } },
	          _react2.default.createElement(_microwavePanel2.default, {
	            sc: this.sc,
	            configuration: this.state && this.state.configuration,
	            datamodel: this.state && this.state.datamodel
	          })
	        )
	      )
	    );
	  };
	
	  return W3CMicrowaveExample;
	}(_common.SCComponent);
	
	exports.default = W3CMicrowaveExample;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonStyle = {
	  margin: '0 0.5rem 0.5rem 0'
	};
	
	var statStyle = {
	  display: 'inline-block',
	  minWidth: '7rem',
	  marginRight: '1rem',
	  padding: '0.5rem 0'
	};
	
	var MicrowavePanel = function MicrowavePanel(_ref) {
	  var sc = _ref.sc,
	      configuration = _ref.configuration,
	      datamodel = _ref.datamodel;
	
	  var states = configuration || [];
	  var isOff = states.indexOf('off') > -1;
	  var isIdle = states.indexOf('idle') > -1;
	  var isCooking = states.indexOf('cooking') > -1;
	  var timer = datamodel && typeof datamodel.timer !== 'undefined' ? datamodel.timer : 0;
	  var cookTime = datamodel && datamodel.cook_time ? datamodel.cook_time : 5;
	  var hasDoorRegion = states.indexOf('open') > -1 || states.indexOf('closed') > -1;
	  var doorClosed = hasDoorRegion ? states.indexOf('closed') > -1 : !datamodel || datamodel.door_closed !== false;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { padding: '1rem', height: '100%', background: '#f7f7f7' } },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          height: '13rem',
	          border: '8px solid #444',
	          background: isOff ? '#222' : isCooking ? '#ffc857' : '#dceefb',
	          position: 'relative',
	          marginBottom: '1rem'
	        }
	      },
	      _react2.default.createElement('div', {
	        style: {
	          position: 'absolute',
	          left: '1rem',
	          right: '5rem',
	          top: '1rem',
	          bottom: '1rem',
	          border: doorClosed ? '4px solid #111' : '4px solid #1976d2',
	          background: doorClosed ? 'rgba(255,255,255,0.25)' : '#fff',
	          transform: doorClosed ? 'none' : 'skewY(-6deg)'
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            position: 'absolute',
	            right: '0.75rem',
	            top: '1rem',
	            width: '3.5rem',
	            bottom: '1rem',
	            background: '#2e2e2e',
	            color: '#eee',
	            padding: '0.5rem',
	            textAlign: 'center'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: '1.5rem', fontFamily: 'monospace' } },
	          timer
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: '0.75rem' } },
	          'sec'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { style: statStyle },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Power'
	        ),
	        _react2.default.createElement('br', null),
	        isOff ? 'off' : 'on'
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: statStyle },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Mode'
	        ),
	        _react2.default.createElement('br', null),
	        isCooking ? 'cooking' : isIdle ? 'idle' : 'off'
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: statStyle },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Door'
	        ),
	        _react2.default.createElement('br', null),
	        doorClosed ? 'closed' : 'open'
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: statStyle },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Timer'
	        ),
	        _react2.default.createElement('br', null),
	        timer,
	        ' / ',
	        cookTime
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '1rem' } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', style: buttonStyle, onClick: function onClick() {
	            return sc && sc.gen('turn.on');
	          } },
	        'Turn on'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: buttonStyle, onClick: function onClick() {
	            return sc && sc.gen('turn.off');
	          } },
	        'Turn off'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-info', style: buttonStyle, onClick: function onClick() {
	            return sc && sc.gen('door.open');
	          } },
	        'Open door'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-info', style: buttonStyle, onClick: function onClick() {
	            return sc && sc.gen('door.close');
	          } },
	        'Close door'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', style: buttonStyle, onClick: function onClick() {
	            return sc && sc.gen('time');
	          } },
	        'Tick'
	      )
	    )
	  );
	};
	
	exports.default = MicrowavePanel;
	module.exports = exports['default'];

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\"?>\n<scxml xmlns=\"http://www.w3.org/2005/07/scxml\"\n       version=\"1.0\"\n       datamodel=\"ecmascript\"\n       initial=\"off\">\n\n  <!-- trivial 5 second microwave oven example -->\n  <datamodel>\n    <data id=\"cook_time\" expr=\"5\"/>\n    <data id=\"door_closed\" expr=\"true\"/>\n    <data id=\"timer\" expr=\"0\"/>\n  </datamodel>\n\n  <state id=\"off\">\n    <transition event=\"turn.on\" target=\"on\"/>\n  </state>\n\n  <state id=\"on\">\n    <initial>\n      <transition target=\"idle\"/>\n    </initial>\n\n    <transition event=\"turn.off\" target=\"off\"/>\n    <transition cond=\"timer &gt;= cook_time\" target=\"off\"/>\n\n    <state id=\"idle\">\n      <transition cond=\"door_closed\" target=\"cooking\"/>\n      <transition event=\"door.close\" target=\"cooking\">\n        <assign location=\"door_closed\" expr=\"true\"/>\n      </transition>\n    </state>\n\n    <state id=\"cooking\">\n      <transition event=\"door.open\" target=\"idle\">\n        <assign location=\"door_closed\" expr=\"false\"/>\n      </transition>\n\n      <transition event=\"time\">\n        <assign location=\"timer\" expr=\"timer + 1\"/>\n      </transition>\n    </state>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _w3cMicrowaveExample = __webpack_require__(410);
	
	var _w3cMicrowaveExample2 = _interopRequireDefault(_w3cMicrowaveExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Microwave = function Microwave(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports the W3C microwave oven example from Alex Zhornyak\'s SCXML tutorial collection into a browser-executable SCION example. The left pane shows the live statechart, and the right pane is an HTML5 microwave panel that sends SCXML events.'
	    ),
	    React.createElement(_w3cMicrowaveExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _w3cMicrowaveExample.microwaveScxml
	    )
	  );
	};
	
	var WrappedMicrowave = function WrappedMicrowave(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Microwave, pathname: location.pathname });
	};
	
	exports.default = WrappedMicrowave;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-microwave-js-3b98826bfd7eb94560fc.js